import React from 'react';
import { useParams } from 'react-router-dom';

import { FicheDescriptiveDisplay } from 'components/FicheDescriptiveDisplay/FicheDescriptiveDisplay';
import Spinner from 'components/WrappedComponents/Spinner';
import { DossierProvider } from 'hooks/dossiers/DossierContext';
import { useFetchDossier } from 'hooks/dossiers/useFetchDossier';
import { PageDossierParam } from 'types/pageDossier';

import ActionsSuiviVehicule from '../Components/ActionsSuiviVehicule/ActionsSuiviVehicule';

export const Details: React.FC = () => {
  const { id } = useParams<PageDossierParam>();

  if (id === undefined) {
    throw new Error("L'Id du dossier est null");
  }

  const [dossier, setDossier] = useFetchDossier(id);

  if (dossier === null) {
    return <Spinner />;
  }

  return (
    <DossierProvider
      value={{
        dossier: { result: dossier, setDossier: setDossier },
      }}
    >
      <FicheDescriptiveDisplay>
        <ActionsSuiviVehicule />
      </FicheDescriptiveDisplay>
    </DossierProvider>
  );
};
